import { apiSlice } from '@/api';
import {
  Budget,
  BudgetResponse,
  GetSummaryResponse,
  MyScreensSummary,
  Screens,
} from './type';

// TODO: move budget to a separate config feature

export const companyScreensApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getScreens: builder.query<Screens, void>({
      query: () => ({
        url: 'v1/partner/screens/my-screens',
      }),
    }),
    getScreensSummary: builder.query<MyScreensSummary, void>({
      query: () => ({
        url: 'v1/partner/screens/summary',
      }),
      transformResponse: (res: GetSummaryResponse) => res.result,
    }),
    getBudget: builder.query<Budget, void>({
      query: () => ({
        url: `v1/points/budget`,
      }),
      transformResponse: (res: BudgetResponse) => res.result,
    }),
  }),
});

export const {
  useGetScreensQuery,
  useGetScreensSummaryQuery,
  useGetBudgetQuery,
} = companyScreensApi;
